/* eslint-disable @typescript-eslint/no-unused-vars */
import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { WorkOnProjectMutator } from '@/lib/entity/work_on_project'
import type { Converter } from '@/lib/converter/entityFormatter'
import { layered } from '@/lib/layered'
import type { Kysely } from 'kysely'
import type { DB } from '@/lib/kysely-d'
import { asModifiedField } from '@/lib/converter/entityFormatter'
import { formatDate } from '@/lib/dateFormatUtil'

type WorkOnProjectSchema = WorkOnProjectMutator['merged']

export const WorkOnProjectConverter: Converter<WorkOnProjectSchema> = {
  icon: () => i18next.t('stages.icon.work_on_project'),
  title: () => i18next.t('stages.table.work_on_project'),
  subTitle: async (merged) => {
    const queryResult = await projectNameQuery(merged.project_id!)
    const subTitle = queryResult.name
    return subTitle.merged() ?? subTitle.get('BASE') ?? ''
  },
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.work_on_project.${column}`)
    return match(column)
      .with('actuals', (column) => {
        const value: string[] = []
        Object.entries(modified.actuals!).forEach(([date, actual]) => {
          value.push(formatDate(date, 'MM月dd日') + `(${actual})`)
        })
        return asModifiedField(label, value.sort())
      })
      .with('comments', (column) => {
        const value: string[] = []
        if (modified.comments) {
          Object.entries(modified.comments!).forEach(([date, comment]) => {
            if (comment != null && comment.length > 0) {
              value.push(formatDate(date, 'MM月dd日') + `(${comment})`)
            }
          })
        }
        return asModifiedField(label, value.sort())
      })
      .with('id', 'project_id', 'user_id', 'assign_id', 'month', () => undefined)
      .exhaustive()
  }
}

const projectNameQuery = async (id: string) => {
  return await layered(async (db: Kysely<DB>) => {
    const result = await db
      .selectFrom('project')
      .select(['project.name'])
      .where('project.id', '=', id)
      .executeTakeFirst()
    if (!result) {
      return { name: null }
    }
    return result
  })
}
